import React from "react";
import { FaQuoteLeft, FaUserCircle } from "react-icons/fa";
import "./Testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Santhanam s",
    role: "Chatered Accountant",
    city: "Chennai",
    text: "Sai Bhavana Realty made buying my first property seamless. Every interaction was friendly, transparent, and helpful. They really listen to your needs and go the extra mile to ensure satisfaction."
  },
  {
    id: 2,
    name: "Vaishnavi",
    role: "Professor",
    city: "Coimbatore",
    text: "I sold my property in record time thanks to their expert marketing and negotiation skills. The process was stress-free, and I got a great price"
  },
  {
    id: 3,
    name: "Niharika Gowda",
    role: "Teacher",
    city: "Orissa",
    text: "Working with this team was seamless from start to finish. They understood exactly what we were looking for and guided us through every step of buying our flat."
  },
  {
    id: 4,
    name: "Sathya Narayana",
    role: "Technical Lead",
    city: "Banglore",
    text: "Excellent customer support and verified properties. They assisted me in selecting a land plot. Highly recommended!"
  }
];

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <h2 className="section-title">What Our Clients Say</h2>
      <div className="testimonials-container">
        {testimonials.map(t => (
          <div key={t.id} className="testimonial-card">
            <FaQuoteLeft className="quote-icon"/>
            <p className="testimonial-text">"{t.text}"</p>
            <div className="customer-info">
              <FaUserCircle className="user-icon"/>
              <div>
                <h4>{t.name}</h4>
                <p className="testimonial-role">{t.role} - {t.city}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;